<template>
  <div id="app" :style="bg">
    <topnav v-if="isTopNavAlive" class="app_topnav" />
    <router-view class="app_routerview" />
  </div>
</template>

<script>
import topnav from "./components/Global/TopNav.vue";
import GLOBAL from "@/utils/global.js";

export default {
  name: "App",
  components: {
    topnav,
  },
  provide() {
    return {
      reloadTopNav: this.reloadTopNav, // 将“重新加载导航栏”方法暴露
      hideTopNav: this.hideTopNav,
    };
  },


  data() {
    return {
      bg:{
      },
      isTopNavAlive: true, // 导航栏是否已加载flag
    };
  },

  methods: {
    // 重新加载导航栏
    reloadTopNav() {
      // this.isTopNavAlive = false;
      this.$nextTick(function () {
        this.isTopNavAlive = true;
        this.bg.background='';
      });
    },
    hideTopNav() {
      this.$nextTick(function () {
        this.isTopNavAlive = false;
        this.bg.background='linear-gradient(200deg, #f3e7e9, #e3eeff)';
      });
    }
  },
  mounted() {
    this.$router.onReady(() => {
      this.$store.commit('refreshVisitorMode');
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.$route);
      }
      if (this.$route.path === "/") {
        this.isTopNavAlive = false;
        this.bg.background='linear-gradient(200deg, #f3e7e9, #e3eeff)';
      }

    });

  },

};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
}
*{
  margin: 0 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
  height: 100%;
  overflow: auto;
}


.app_topnav {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  z-index: 2000;
}

.app_routerview {
  position: relative;
  top: 0px;
  left: 0px;
  right: 0px;
}
</style>
